import AbstractComponent from './abstract-component.js';

const createParagraphTemplate = ({title, value}) => {
  return (
    `<li class="product-list__itemProperty">
      <p class="product-list__itemPropertyText">${title}: <span>${value}</span></p>
    </li>`
  );
};


export default class PropertyItemComponent extends AbstractComponent {
  constructor({property}) {
    super();

    this._property = property;
  }

  getTemplate() {
    return createParagraphTemplate(this._property);
  }
}
